export default __webpack_public_path__ + "static/media/notFound404.e27329c4.svg";